import {
  CogIcon,
} from '@heroicons/react/outline'
import { GAME_TITLE } from '../../constants/strings'
import strawberry from '../../strawberry.png'

type Props = {
  round: number
  setIsInfoModalOpen: (value: boolean) => void
  setIsStatsModalOpen: (value: boolean) => void
  setIsSettingsModalOpen: (value: boolean) => void
}

export const Navbar = ({
  round,
  setIsInfoModalOpen,
  setIsStatsModalOpen,
  setIsSettingsModalOpen,
}: Props) => {
  return (
    <div className="navbar bg-white dark:bg-black border-slate-500 border-b">
      <div className="navbar-content px-5">
        <div className="w-6 hidden sm:block">

        </div>
        <div className="flex items-center">
          <img className="w-5" src={strawberry} alt="" />
          {round === 2 &&
            <img className="w-5 ml-2" src={strawberry} alt="" />
          }
          <p className="text-md sm:text-xl ml-2.5 font-bold dark:text-white">{GAME_TITLE} #{round}</p>
        </div>
        <div className="right-icons">
          {/* <ChartBarIcon
            className="h-6 w-6 mr-3 cursor-pointer dark:stroke-white"
            onClick={() => setIsStatsModalOpen(true)}
          /> */}
          <CogIcon
            className="h-6 w-6 cursor-pointer dark:stroke-white"
            onClick={() => setIsSettingsModalOpen(true)}
          />
        </div>
      </div>
      <hr></hr>
    </div>
  )
}
